export default __webpack_public_path__ + "static/media/add-circle.aebcaa44.svg";